import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-push-view',
  templateUrl: './push-view.component.html',
  styleUrls: ['./push-view.component.css']
})
export class PushViewComponent implements OnInit {

  notification: any = null;
  logs: any[] = [];
  pnotify = undefined;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    pnotifyService: PNotifyService
  ) {
    console.log('[PushView] Constructor started');
    this.pnotify = pnotifyService.getPNotify();
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.http.get('/api/push/' + id).subscribe((n: any) => {
        this.notification = n;
        this.loadLogs();
      });
    });
  }

  ngOnInit() { }

  loadLogs() {
    this.http.get('/api/push/' + this.notification.id + '/logs', { params: { limit: '100' } })
      .subscribe((resp: any) => {
        this.logs = resp.data || [];
      });
  }

  onCancel() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous annuler cette notification ?',
      stack: { firstpos1: 70, firstpos2: 10, modal: true, overlay_close: true },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok', addClass: 'btn btn-chico',
              click: notice => {
                this.http.post('/api/push/' + this.notification.id + '/cancel', {}).subscribe(() => {
                  this.notification.status = 'cancelled';
                });
                notice.close();
              }
            },
            {
              text: 'Annuler', addClass: 'btn btn-default',
              click: (notice) => { notice.close(); notice.fire('pnotify.cancel', { notice }); }
            }
          ]
        }
      }
    });
  }

  getStatusLabel(status: string): string {
    const labels: any = { draft: 'Brouillon', pending: 'En attente', sent: 'Envoyé', cancelled: 'Annulé', failed: 'Échec' };
    return labels[status] || status;
  }

  getStatusClass(status: string): string {
    const classes: any = { draft: 'label-default', pending: 'label-warning', sent: 'label-success', cancelled: 'label-default', failed: 'label-danger' };
    return classes[status] || 'label-default';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/push/push-view/push-view.component.ts